
import { useQuery } from "@apollo/client";
import { FormikProvider } from "formik";

import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import {
    LIST_ALL_POSITIONS
} from "../../graphql/workers.graphql";
import { getOptions } from "../../utils/array-utils";
import { useReasons } from "../../utils/checkoutReasonsHook";
import DropdownWithFormik from "../Dropdown/DropdownWithFormik";
import TextInputWithFormik from "../TextInput/TextInputWithFormik";


const ReaderForm = ({ checkStatus, job, formik }) => {
    const {
      t,
      i18n: { language },
    } = useTranslation();

    const loadReasons = useReasons();

    const [reasons, setReasons] = useState([]);
  
    useEffect(() => {
      loadReasons(job?.line?.is_misc).then((r) => setReasons(r));
    }, [job?.line?.is_misc, loadReasons]);
    
    const {
      data: positions,
      loading: loadingPositions,
      error: positionsError,
    } = useQuery(LIST_ALL_POSITIONS);
  
    const positionsOptions = getOptions(
      "comment",
      positions?.position,
      loadingPositions,
      positionsError,
      ["comment_es", "is_misc", "is_standard", "code", "base_rate"]
    )
      .filter(
        (p) =>
          ((job.line?.is_misc && p.is_misc) ||
          !job.line?.is_misc) && p.code !== "LINE_LEADER"
      )
      .map((p) => ({
        ...p,
        label: language == "es" && p.comment_es ? p.comment_es : p.label,
      }));
  
    const { handleSubmit, values } = formik;
  
    return (
      <Form id="checkin" noValidate onSubmit={handleSubmit}>
        <FormikProvider value={formik}>
          <div className="d-flex justify-content-between flex-column">
            {checkStatus !== "checkout" && (
              <DropdownWithFormik
                label={t("views.checkin.form.position")}
                name="position"
                placeholder={t("views.checkin.form.positionPlaceholder")}
                options={positionsOptions}
                required
                maxMenuHeight={95}
                containerClass="w-100 my-3"
              />
            )}
            {checkStatus === "checkout" && (
              <>
                <DropdownWithFormik
                  label={t("views.checkin.checkout.form.reason")}
                  name="reason"
                  options={reasons}
                  required
                />
                <TextInputWithFormik
                  label={t("views.checkin.checkout.form.description")}
                  name="description"
                  type="text"
                  placeholder=""
                  required={values.reason?.value === "OTHER"}
                />
              </>
            )}
          </div>
        </FormikProvider>
      </Form>
    );
  };

  
  export default ReaderForm